import classnames from "classnames";
import * as I from "immutable";
import moment from "moment-timezone";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import MediaQuery from "react-responsive";
import {Link} from "react-router";
import {OverlayTrigger, Popover, Button, ButtonGroup} from "react-bootstrap";

import {SERVICE_TYPE} from "config/constants";
import settings from "config/settings";
import {getRouteLabel, noop} from "utils";

import api from "v2/api";
import {apiError} from "v2/api/Errors";
import {getDestination} from "v2/api/Destinations";
import {AppData, Route} from "v2/api/Records";
import {apiRoute} from "v2/api/Routes";

import DestinationActionsDropup from "v2/components/DestinationActionsDropup";
import DestinationsSidebar from "v2/components/DestinationsSidebar";
import DestinationLegend from "v2/components/DestinationLegend";
import Loading from "v2/components/Loading";
import RouteActionsDropdown from "v2/components/RouteActionsDropdown";
import RouteBalanceIcon from "v2/components/RouteBalanceIcon";
import RouteCheckInOrderIcon from "v2/components/RouteCheckInOrderIcon";
import RouteDelay from "v2/components/RouteDelay";
import RoutesGroups from "v2/components/RoutesGroups";
import RouteMap from "v2/components/RouteMap";
import RoutesSearchBox from "v2/components/RoutesSearchBox";
import ServerError from "v2/components/ServerError";
import NotFoundError from "v2/components/NotFoundError";
import StickyFooter from "v2/components/StickyFooter";

import AddDestinationLink from "v2/components/responsive/AddDestinationLink";
import AddRouteLink from "v2/components/responsive/AddRouteLink";
import EditDestinationLink from "v2/components/responsive/EditDestinationLink";

import styles from "v2/styles";


export default class RoutePage extends Component {
  static childContextTypes = {
    onUpdateRouteData: PropTypes.func,
    routeData: PropTypes.instanceOf(Route),
  }
  static contextTypes = {
    appData: PropTypes.instanceOf(AppData),
    dateData: ImmutablePropTypes.listOf(Route),
    location: PropTypes.object,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      id: PropTypes.string,
      routeId: PropTypes.string.isRequired,
    }),
    router: PropTypes.object,
  }
  static propTypes = {
    children: PropTypes.node,
  }

  state = {
    data: I.Map(),
    dataError: I.Map(),
    notFoundError: I.Map(),
    showMap: false,
  }

  getChildContext() {
    const {params: {routeId}} = this.context;
    return {
      onUpdateRouteData: this.loadData,
      routeData: this.state.data.get(routeId),
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {params: {date, routeId}, router} = this.context;
    const {
      location: {pathname: nextPathname, query: nextQuery},
      params: {id: nextId, routeId: nextRouteId},
    } = nextContext;

    if (routeId !== nextRouteId || nextQuery.update) {
      this.loadData(nextContext);

      if (nextQuery.update) {
        router.push({
          pathname: nextPathname,
          query: {
            ...nextQuery,
            update: undefined,
          },
        });
      }
    } else if (!nextId && !(this.mobileEl && this.mobileEl.state.matches)) {
      const data = this.state.data.get(routeId);
      if (data && data.destinations && !data.destinations.isEmpty()) {
        const destination = data.destinations.first();
        router.push({
          pathname: `/${date}/${routeId}/${destination.id}`,
          query: nextQuery,
        });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleDestinationMouseEnter = (destinationID) => {
    this.setState({hoverDestination: destinationID});
  }

  handleDestinationMouseLeave = () => {
    this.setState({hoverDestination: null});
  }

  handleToggleMap = () => {
    this.setState({showMap: !this.state.showMap});
  }

  getApiUrl = (context) => {
    const {params: {routeId}} = (context || this.context);
    return `/routes/${routeId}`;
  }

  getSidebarContent(data, style={}) {
    if (data.destinations.isEmpty()) {
      return [
        <h5
          className="erg-margin-top-30"
          key="header"
          style={{paddingLeft: "15px", textTransform: "uppercase"}}>
          No Destinations
        </h5>,
        <p
          className="erg-padding-left-15 erg-padding-right-10 text-muted"
          key="text">
          This route doesn&apos;t have any destinations. You can add a new one
          by clicking "New Destination" below.
        </p>,
      ];
    }
    return (
      <DestinationsSidebar
        onDestinationMouseEnter={this.handleDestinationMouseEnter}
        onDestinationMouseLeave={this.handleDestinationMouseLeave}
        route={data}
        style={style} />
    );
  }

  isDesinationEditable = (data) => {
    return !data.readOnly;
  }

  loadData = (context, onLoad) => {
    const {
      location: {query},
      params: {date, routeId},
      router,
    } = (context || this.context);

    api()
      .get(this.getApiUrl(context), {
        params: {
          "_": moment().unix(),
        },
      })
      .then((response) => {
        if (!this._isMounted) {
          return;
        }
        if (response.data.date !== date) {
          this.setState(({notFoundError}) => ({
            notFoundError: notFoundError.set(routeId, "The selected route is not part of this date."),
          }));
        }

        this.setState(({data}) => ({
          data: data.set(routeId, apiRoute(response.data)),
        }), () => {
          (onLoad || noop)();

          const {params: {id}} = this.context;
          if (this.mobileEl.state.matches || id) {
            return;
          }

          const data = this.state.data.get(routeId);
          const destination = data.destinations.first();
          if (destination) {
            router.push({
              pathname: `/${date}/${routeId}/${destination.id}`,
              query,
            });
          }
        });
      })
      .catch((err) => {
        if (!this._isMounted) {
          return;
        }

        if (err.response) {
          this.setState(({dataError}) => ({
            dataError: dataError.set(routeId, apiError(err.response.data)),
          }));
        } else {
          Raven.captureException(err);
        }
      });
  }

  renderMap() {
    const {params: {id, routeId}} = this.context;
    const {data, hoverDestination} = this.state;
    const heightDiff = settings.LEVEL === "production" ? 160 : 210;

    const destinations = data.get(routeId).get("destinations");

    return (
      <RouteMap
        activeDestination={id}
        destinations={destinations}
        height={`calc(100vh - ${heightDiff + 60}px)`}
        highlightDestination={hoverDestination} />
    );
  }

  renderDesktop(hideRoutesSidebar=false) {
    const getWrapperStyle = (number) => ({
      minHeight: `calc(100vh - ${number}px)`,
    });

    const {
      appData: {destinationTypeEditable, serviceType},
      dateData,
      params: {date, id, routeId},
    } = this.context;
    const {children} = this.props;

    const addBtnStyle = {
      backgroundColor: styles.COLOR.BG_LIGHTGREY,
      borderRight: styles.BORDER,
      width: hideRoutesSidebar ? "200px" : "250px",
    };
    const heightDiff = settings.LEVEL === "production" ? 160 : 210;

    const data = this.state.data.get(routeId);
    const dataError = this.state.dataError.get(routeId);
    const notFoundError = this.state.notFoundError.get(routeId);

    let content;
    if (data === undefined && dataError === undefined && notFoundError === undefined) {
      content = <Loading />;
    } else if (dataError) {
      content = <ServerError data={dataError} />;
    } else if (notFoundError) {
      content = <NotFoundError message={notFoundError} />;
    } else {
      const heightStyle = {
        height: "60px",
      };
      const headerStyle = {
        ...heightStyle,
        fontSize: "2rem",
        lineHeight: "60px",
      };
      const labelStyle = {
        ...heightStyle,
        borderBottom: styles.BORDER,
      };

      let headerContent = [
        getRouteLabel(data),
        <small className="erg-margin-left-20" key="type">
          {serviceType.get(data.type)}
        </small>,
        <RouteBalanceIcon
          balance={data.balance}
          className="erg-margin-left-15 erg-font-sm"
          key="balance"
          visible={moment(data.date).isAfter(moment(), "day")} />,
        <RouteCheckInOrderIcon
          className="erg-margin-left-15 erg-font-sm"
          isValid={data.correctCheckinOrder}
          key="order" />,
        <RouteDelay
          className="erg-margin-left-15 erg-font-sm"
          delay={data.delay}
          key="delay" />,
      ];
      if (hideRoutesSidebar) {
        headerContent = <Link to={`/${date}`}>{headerContent}</Link>;
      }

      let dropdownClassName;
      if (data.type === SERVICE_TYPE.maintenance) {
        dropdownClassName = "erg-margin-left-15";
      }
      dropdownClassName = classnames("erg-inline-block", dropdownClassName);
      content = [
        <div
          className="clearfix erg-padding-left-15 erg-padding-right-15"
          key="label"
          style={labelStyle}>
          <h1 className="erg-no-margin pull-left" style={headerStyle}>
            {headerContent}
          </h1>
          <div
            className="erg-margin-top-15 pull-right small"
            style={{height: "30px", lineHeight: "30px"}}>
            <ButtonGroup className="erg-margin-right-30">
              <Button active={!this.state.showMap} bsSize={"small"} onClick={this.handleToggleMap}>Info</Button>
              <Button active={this.state.showMap} bsSize={"small"} onClick={this.handleToggleMap}>Map</Button>
            </ButtonGroup>
            <OverlayTrigger
              overlay={<Popover
                className="erg-font-sm"
                id="destination-legend">
                <DestinationLegend />
              </Popover>}
              placement="bottom"
              rootClose
              trigger="click">
              <span className="legend-button erg-padding-right-15 ">
                <span className="legend-text">Legend</span>
                <span className="caret" />
              </span>
            </OverlayTrigger>
            <RouteActionsDropdown
              className={dropdownClassName}
              ref={(el) => this.routeActionsDropdown = el} />
          </div>
        </div>,
        <div
          className="erg-content-with-sidebar-wrapper"
          key="content"
          style={getWrapperStyle(heightDiff + 60)}>
          <div className="erg-sidebar" style={{width: styles.WIDTH.SIDEBAR}}>
            {this.getSidebarContent(data, styles.scrollableSidebar(heightDiff + 60))}
          </div>
          <div className="erg-content-with-sidebar">
            {this.state.showMap ? this.renderMap() : children}
          </div>
        </div>,
      ];
    }

    if (!hideRoutesSidebar) {
      content = [
        <div className="erg-sidebar" key="sidebar">
          <RoutesSearchBox
            noFocus
            placeholder="Gardener or type"
            sidebar />
          <RoutesGroups
            data={dateData}
            heightDiff={heightDiff + 60}
            sidebar />
        </div>,
        <div className="erg-content-with-sidebar" key="content">
          {content}
        </div>,
      ];
    }

    let destinationFooter;
    if (id && data && getDestination(data, id)) {
      const isDesinationEditable = this.isDesinationEditable(data, id);
      const destinationEditControls = (
        destinationTypeEditable.get(getDestination(data, id).type) ?
        [
          isDesinationEditable ? <EditDestinationLink key="edit" /> : null,
          <DestinationActionsDropup
            className="erg-margin-left-15"
            editable={isDesinationEditable}
            key="actions" />,
        ] :
        null
      );

      destinationFooter = (
        <div
          className="DestinationPage-Padding"
          style={{
            backgroundColor: styles.COLOR.BG_WHITE,
            marginLeft: hideRoutesSidebar ? 300 : 550,
          }}>
          {destinationEditControls}
        </div>
      );
    }

    return (
      <div>
        <div
          className="erg-content-with-sidebar-wrapper"
          style={getWrapperStyle(heightDiff)}>
          {content}
        </div>
        <StickyFooter
          className=""
          style={destinationFooter ? {overflow: "visible"} : {}}>
          {!hideRoutesSidebar &&
            <AddRouteLink
              className="pull-left text-center"
              style={addBtnStyle} />}
          {data && !data.readOnly &&
            <AddDestinationLink
              className="pull-left text-center"
              icon="plus-circle"
              linkClassName="erg-add-link"
              style={{
                ...addBtnStyle,
                backgroundColor: styles.COLOR.BG_LIGHTGREY,
                width: styles.WIDTH.SIDEBAR,
              }} />}
          {destinationFooter}
        </StickyFooter>
      </div>
    );
  }

  renderMobile() {
    const {
      appData: {destinationTypeEditable, serviceType},
      location: {query},
      params: {date, id, routeId},
      router,
    } = this.context;
    const {children} = this.props;

    const data = this.state.data.get(routeId);
    const dataError = this.state.dataError.get(routeId);
    const notFoundError = this.state.notFoundError.get(routeId);
    const isIndex = router.isActive(`/${date}/${routeId}`, true);
    const isIdIndex = router.isActive(`/${date}/${routeId}/${id}`, true);

    let content;
    if (data === undefined && dataError === undefined && notFoundError === undefined) {
      content = <Loading />;
    } else if (dataError) {
      content = <ServerError data={dataError} />;
    } else if (notFoundError) {
      content = <NotFoundError message={notFoundError} />;
    } else {
      const headerStyle = {
        backgroundColor: styles.COLOR.BG_LIGHTGREY,
        borderBottom: styles.BORDER,
      };
      let headerUrl = `/${date}`;
      if (!isIndex) {
        headerUrl = `${headerUrl}/${routeId}`;
      }

      content = (
        <div>
          <div
            className="erg-padding-15"
            style={headerStyle}>
            <Link to={{pathname: headerUrl, query}}>
              <strong>{getRouteLabel(data)}</strong>
              <small className="erg-margin-left-10">
                {serviceType.get(data.type)}
              </small>
            </Link>
            <RouteActionsDropdown className="pull-right" />
          </div>
          {isIndex ? this.getSidebarContent(data) : children}
        </div>
      );
    }

    let footerContent;
    let footerStyle = null;
    if (isIndex && data) {
      footerContent = (
        <AddDestinationLink
          className="col-xs-12 text-center"
          icon="plus-circle"
          linkClassName="erg-add-link"
          style={{backgroundColor: styles.COLOR.BG_LIGHTGREY}} />
      );
    } else if (isIdIndex && id && data && getDestination(data, id)) {
      footerStyle = {
        overflow: "visible",
      };
      const isDesinationEditable = this.isDesinationEditable(data, id);
      const destinationEditControls = (
        destinationTypeEditable.get(getDestination(data, id).type) ?
        [
          isDesinationEditable ? (
            <EditDestinationLink
              component="span"
              icon="pencil"
              key="edit"
              linkClassName="erg-add-link" />
          ) : null,
          <DestinationActionsDropup
            className="erg-margin-left-10"
            editable={isDesinationEditable}
            key="actions" />,
        ] :
        null
      );
      footerContent = (
        <div
          className="col-xs-12"
          style={{backgroundColor: styles.COLOR.BG_WHITE}}>
          <div className="erg-padding-left-15 erg-padding-right-15">
            {destinationEditControls}
          </div>
        </div>
      );
    }

    return (
      <div>
        {content}
        {footerContent &&
          <StickyFooter style={footerStyle}>
            {footerContent}
          </StickyFooter>}
      </div>
    );
  }

  render() {
    return (
      <div>
        <MediaQuery
          maxWidth={768}
          ref={el => this.mobileEl = el}>
          {this.renderMobile()}
        </MediaQuery>
        <MediaQuery
          maxWidth={992} minWidth={768}
          ref={el => this.tabletEl = el}>
          {this.renderDesktop(true)}
        </MediaQuery>
        <MediaQuery
          minWidth={992}
          ref={el => this.desktopEl = el}>
          {this.renderDesktop()}
        </MediaQuery>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/RoutePage.js
 **/